module.exports = __webpack_public_path__ + "img/010-wind-4.d2df57c8.svg";